import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import DateFormat from '../../../commons/componentes/DateFormat';
import { FaCheckCircle } from '@react-icons/all-files/fa/FaCheckCircle';
import { FaTimesCircle } from '@react-icons/all-files/fa/FaTimesCircle';

const GrupoEmpresasTabla = (props: any) => {

    const { grupoId, empresaId, empresas, seleccionarEmpresa, deseleccionarEmpresa }: { grupoId: string; empresaId: string, empresas: any[], seleccionarEmpresa?: any, deseleccionarEmpresa?: any } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table tabla-chica" style={{ minWidth: 640 }}>
                <thead>
                    <tr className='bg-primary'>
                        <th>Razón Social</th>
                        <th>RFC</th>
                        <th>Venc. Sellos</th>
                        <th>Clave Fiel</th>
                        <th>Venc. Fiel</th>
                        <th>Clave Ciec</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {empresas.map((empresa, index: number) => (
                        <tr key={empresa.id ?? index}
                            className={empresa.id === Number(empresaId) ? "selected" : ""}
                        >
                            <td>{empresa.razonSocial}</td>
                            <td>{empresa.rfc}</td>
                            <td><DateFormat value={empresa.vsellos}></DateFormat></td>
                            <td>{empresa.cfiel}</td>
                            <td><DateFormat value={empresa.vfiel}></DateFormat></td>
                            <td>{empresa.cciec}</td>
                            <td style={{ textAlign: 'center' }}>
                                {empresa.estatus == 1
                                    ? <FaCheckCircle style={{ color: '#22c55e', fontSize: 18 }} title="Activo" />
                                    : <FaTimesCircle style={{ color: '#ef4444', fontSize: 18 }} title="Inactivo" />
                                }
                            </td>
                            <td>
                                {empresa.id != Number(empresaId) && <button className='btn btn-sm btn-primary' onClick={() => { seleccionarEmpresa(empresa); }}>Seleccionar</button>}
                                {empresa.id === Number(empresaId) && <button className='btn btn-sm btn-primary' onClick={() => { deseleccionarEmpresa(empresa); }}>Cerrar</button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GrupoEmpresasTabla;
